/**
 * toOption
 * - Convert raw data into option structure
 * @param rawOption
 * @returns
 */
export const toOption = (rawOption) => {
    return typeof rawOption === 'string' ? { label: rawOption, value: rawOption } : rawOption;
};
export const toLabel = (rawOption) => {
    return (typeof rawOption === 'string' ? rawOption : rawOption === null || rawOption === void 0 ? void 0 : rawOption.label) || '';
};
/**
 * toValue
 * - Handle all the variety of allowed data-structures for options
 * & convert them into a basic string value for comparison (find/filter/map/includes/===)
 * @param rawOption
 * @returns {string | undefined} stringified value, if found
 */
export const toValue = (rawOption) => {
    switch (typeof rawOption) {
        case 'number':
            return String(rawOption);
        case 'object':
            if (rawOption.value) {
                switch (typeof rawOption.value) {
                    case 'number':
                        return String(rawOption.value);
                    case 'object':
                        return JSON.stringify(rawOption.value);
                    case 'string':
                        return rawOption.value;
                }
            }
            return;
        case 'string':
            return rawOption;
        default:
            return;
    }
};
